import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { CONTRACT_STATE_TEMPLATE_API } from "./apiRoutes";

const mutateAddStateLaw = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${CONTRACT_STATE_TEMPLATE_API}`, data);
};

const useAddStateLawMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddStateLaw,
    ...queryParams,
  });

export default useAddStateLawMutation;
